<template>
  <div
    class="characteristic fs-sm-14 grid-row grid-row_xs d-flex_between pt-8"
    v-for="item of unitedFeatures"
    :key="item"
  >
    <div class="grid-col grid-col_50 grid-col_md-full">
      <div class="characteristic__title color-gray d-flex d-flex_baseline">
        {{ item.name }}
      </div>
    </div>

    <template v-if="item.name === 'Бренд'">
      <a :href="item.link" class="grid-col grid-col_50 color-tertiary">
        {{ item.value }}
      </a>
    </template>
    <div v-else class="grid-col grid-col_50">
      {{ item.value }}
    </div>
  </div>
</template>

<script>
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { mapState } from "pinia";

export default {
  name: "Characteristic",
  setup() {
    const store = useProductStore();

    return {
      store,
    };
  },
  computed: {
    ...mapState(useProductStore, [
      "getFeaturesList",
      "getOfferFeaturesList",
      "getSelectedProduct",
    ]),
    unitedFeatures() {
      let unitedFeatures = Object.fromEntries(
        Object.values(this.getFeaturesList ?? {})
          .concat(Object.values(this.getOfferFeaturesList ?? {}))
          .map((value, index) => [index, value])
      );

      return unitedFeatures;
    },
  },
};
</script>

<style lang="scss">
@import "./characteristic.scss";
</style>
